const ReturnsInfoIcon = ({ ...props }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.28466 11.2713V4.49161C4.28466 2.93147 5.54938 1.66675 7.10952 1.66675H4.99087C3.43074 1.66675 2.16602 2.93147 2.16602 4.49161V11.2713C2.16602 12.8314 3.43074 14.0961 4.99087 14.0961H7.10952C5.54938 14.0961 4.28466 12.8314 4.28466 11.2713Z"
        fill="#FB3973"
        fillOpacity="0.2"
      />
      <path
        d="M7.53325 14.0961H4.99087C3.43074 14.0961 2.16602 12.8314 2.16602 11.2713V4.49161C2.16602 2.93147 3.43074 1.66675 4.99087 1.66675H11.7705C13.3307 1.66675 14.5954 2.93147 14.5954 4.49161V7.03398"
        stroke="#663D20"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.501 4.49146V5.90388C10.501 6.68393 9.86858 7.31631 9.08853 7.31631H7.6761C6.89605 7.31631 6.26367 6.68393 6.26367 5.90388V4.49146"
        stroke="#663D20"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1832 9.85864L11.3571 11.6848C10.8055 12.2364 10.8055 13.1307 11.3571 13.6823L13.1832 15.5084"
        stroke="#FB3973"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9434 12.6836H16.008C17.5681 12.6836 18.8329 13.9483 18.8329 15.5085C18.8329 17.0686 17.5681 18.3333 16.008 18.3333H14.5956"
        stroke="#FB3973"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ReturnsInfoIcon;
